export default "__VITE_ASSET__DWyvURWk__"